import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/comics';

interface RankingListProps {
  comics: ComicItem[];
  title: string;
  icon: string;
}

export default function RankingList({ comics, title, icon }: RankingListProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
      <h3 className="flex items-center gap-2 text-base font-heading text-foreground-900 mb-4">
        <i className={`${icon} text-accent-500 text-lg`}></i>
        {title}
      </h3>
      <div className="space-y-1">
        {comics.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold whitespace-nowrap ${
              index === 0
                ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                : index === 1
                ? 'bg-secondary-500 text-background-50 dark:text-foreground-950'
                : index === 2
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                : 'bg-background-200 text-foreground-600'
            }`}>
              {index + 1}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                {comic.title}
              </p>
              <p className="text-xs text-foreground-500 truncate">{comic.author}</p>
            </div>
            <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{comic.rating}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}